import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import ModalMensaje from "../general/ModalMensaje";
import { Toast,ToastContainer } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Unauthorized from "../general/Unauthorized";

function Usuarios() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [estadoModal, setEstadomodal] = useState('hidden');
    const [mensajeNuevoUsuario, setMensajeNuevoUsuario] = useState('');
    let userdata = [];
    let nuevoUsuario = '';
    let clientData = [];

    const [terminoBusqueda, setTerminoBusqueda] = useState('');

    const [toastMsg, setToastMsg] = useState('');
    const [showToast, setShowToast] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    
    const cols = [
        { 
            name: 'Nombre', 
            cell: row => (
                <span title={`${row.name} ${row.lastname}`}>
                    {row.name} {row.lastname}
                </span>
            ),
            sortable: true 
        },
        { 
            name: 'Cargo', 
            cell: row => (
                <span title={row.cargo || 'Sin cargo'}>
                    {row.cargo || '-'}
                </span>
            )
        },
        { 
            name: 'Documento', 
            cell: row => (
                <span title={`${row.tipo_documento} ${row.numero_documento}`}>
                    {row.tipo_documento} {row.numero_documento}
                </span>
            ),
            sortable: true 
        },
        { 
            name: 'Email', 
            cell: row => (
                <span title={row.email}>
                    {row.email}
                </span>
            ),
            sortable: false 
        },
        { 
            name: 'Celular', 
            cell: row => (
                <span title={row.celular || 'Sin celular'}>
                    {row.celular || '-'}
                </span>
            ),
            sortable: false 
        },
        { 
            name: 'Acción', 
            cell: row => getBotones(row), 
            minWidth: '15%' 
        }
    ];

    const getBotones = (item) => {
        
        return (
            <>
            <Link to={'/editar-usuario?id='+item.id} className="btn btn-primary btn-sm"><i className="far fa-edit"></i>&nbsp;Editar</Link>&nbsp;
            {/*<Link to={'#'} onClick={() => showModal(item.id)} className="btn btn-primary btn-sm"><i className="fas fa-trash-alt"></i>&nbsp;Eliminar</Link>*/}
            </>
        )
    }

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a gestión de personal (con fallback)
        let tienePermiso = false;
        
        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'gestionPersonal');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('gestionPersonal')) {
            tienePermiso = true;
        }
        
        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        /*if (localStorage.getItem('nuevo_usuario')) {
            nuevoUsuario = localStorage.getItem('nuevo_usuario');

            setEstadomodal('visible');
            setMensajeNuevoUsuario('Se ha enviado un mensaje a '+nuevoUsuario+' con la información necesaria para activar su cuenta.');

            localStorage.removeItem('nuevo_usuario');
        }*/

        if (localStorage.getItem('edit_usuario')) {
            setToastMsg('El usuario '+localStorage.getItem('edit_usuario')+' ha sido modificado');
            localStorage.removeItem('edit_usuario');
            setTimeout(() => { setShowToast(true) },800);
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        
        // Cargar información del cliente
        axios.get('/get-client', config)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('Error cargando cliente:', error);
            });

        // Cargar usuarios - SIN parámetro uid (se extrae del token JWT)
        setLoading(true);
        axios.get('/usuarios', config)
            .then(response => {
                if (response.status===200) {
                    setItems(response.data);
                    setLoggedIn(true);
                    setLoading(false);
                }
            })
            .catch(error => {
                console.error('Error cargando usuarios:', error);
                setError(error.response?.data || error.message);
                setLoading(false);
            });
    },[]);


    useEffect(() => {
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                termino: terminoBusqueda
            }
        }

        // Buscar usuarios - SIN parámetro uid (se extrae del token JWT)
        axios.get('/usuarios', config)
            .then(response => {
                setItems(response.data);
            })
            .catch(error => {
                console.error('Error en búsqueda de usuarios:', error);
            })

    },[terminoBusqueda]);



    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/personal-proveedores">Administrador de Personal y Proveedores</Link></li>
                                        <li className="breadcrumb-item" key="bc4">Personal y Profesionales</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Personal y Profesionales</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            
                        <div className="row">
                            <div className="col-md-9">
                                <Link to="/nuevo-usuario" className="btn btn-primary">Crear Nuevo</Link>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label htmlFor="terminoBusqueda">Buscar</label>
                                    <input type="text" name="terminoBusqueda" className="form-control" id="terminoBusqueda" onChange={(e) => setTerminoBusqueda(e.target.value)} />
                                </div>
                            </div>
                        </div>



                        <div className="row">
                            <div className="col-md-12">
                                
                                {loading ? (
                                    <div className="text-center">
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Cargando usuarios...</span>
                                        </div>
                                        <p>Cargando usuarios...</p>
                                    </div>
                                ) : error ? (
                                    <div className="alert alert-danger">
                                        <strong>Error al cargar usuarios:</strong><br/>
                                        {JSON.stringify(error)}
                                    </div>
                                ) : (
                                    <DataTable
                                        columns={cols}
                                        data={items}
                                        pagination
                                        paginationComponentOptions={{
                                            rowsPerPageText: 'Filas por página:',
                                            rangeSeparatorText: 'de',
                                            noRowsPerPage: false,
                                            selectAllRowsItem: true,
                                            selectAllRowsItemText: 'Todos'
                                        }}
                                        noDataComponent="No hay registros para mostrar"
                                        id={'usuarios'}
                                    />
                                )}

                            </div>          
                        </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} message={toastMsg} />

                <ToastContainer className="toast-exito">
                    <Toast onClose={() => setShowToast(false)} show={showToast} delay={4000} autohide>
                        <Toast.Body>{toastMsg}</Toast.Body>
                    </Toast>
                </ToastContainer>


                <ModalMensaje mensaje={mensajeNuevoUsuario} estadoInicial={estadoModal} accion={null} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default Usuarios;